import { testimonials } from "@/mocks/site";

const principles = [
  { icon: "ri-file-list-3-line", title: "只做公开信息整理", text: "所有引用都来自可查证的公开内容，并标注大致出处。" },
  { icon: "ri-scales-3-line", title: "区分事实与推测", text: "正文中明确分开「已知」与「存疑」，不把猜测写成结论。" },
  { icon: "ri-time-line", title: "时间顺序优先", text: "先按发生顺序铺开，再谈解读，避免因果被倒置。" },
];

export default function VoiceSection() {
  return (
    <section className="container-x py-14 md:py-20">
      <div className="max-w-2xl">
        <p className="text-xs font-medium tracking-[0.2em] text-primary-600">PRINCIPLES / 内容原则</p>
        <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          我们坚持的三件小事
        </h2>
      </div>

      <div className="mt-9 grid grid-cols-1 gap-5 md:grid-cols-3">
        {principles.map((item) => (
          <div key={item.title} className="rounded-lg border border-background-200 bg-background-50 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
              <i className={`${item.icon} text-xl`}></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
            <p className="mt-2 text-sm leading-7 text-foreground-600">{item.text}</p>
          </div>
        ))}
      </div>

      <div className="mt-14">
        <h3 className="font-heading text-lg font-bold text-foreground-950">读者怎么说</h3>
        <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-lg border border-background-200 bg-background-100 p-5"
            >
              <i className="ri-double-quotes-l text-2xl text-accent-500"></i>
              <blockquote className="mt-3 flex-1 text-sm leading-7 text-foreground-700">
                {item.text}
              </blockquote>
              <figcaption className="mt-4 border-t border-background-200 pt-4">
                <span className="block font-heading text-sm font-bold text-foreground-950">{item.name}</span>
                <span className="mt-0.5 block text-xs text-foreground-500">{item.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}